import Icon from '@Shared/Icon';
import React from 'react';

const StepsButton: React.FC = () => {

  return (
    <div style={{ marginTop: 42 }}>
      <a className="btn btn-warning btn-lg btn-block" id="get_started_button" href="#/get-started">
        <Icon name="arrow-circle-right fas" style={{ float: 'right' }} className="hidden-xs hidden-sm" size="3x" />
        3 Steps to Get Started<br /><small><small>NEW APPLICATION USERS ONLY!</small></small>
      </a>
    </div>
  );
}

export default StepsButton;